
export function chatbot(){
  // window.addEventListener('mouseover', initLandbot, { once: true });
  // window.addEventListener('touchstart', initLandbot, { once: true });
  // var myLandbot;
  // function initLandbot() {
  //   if (!myLandbot) {
  //     var s = document.createElement('script');s.type = 'text/javascript';s.async = true;
  //     s.addEventListener('load', function() {
  //       var myLandbot = new Landbot.Livechat({
  //         configUrl: 'https://storage.googleapis.com/landbot.site/v3/H-1721315-KERK2IIVK1B2SXW1/index.json',
  //       });
  //     });
  //     s.src = 'https://cdn.landbot.io/landbot-3/landbot-3.0.0.js';
  //     var x = document.getElementsByTagName('script')[0];
  //     x.parentNode.insertBefore(s, x);
  //   }
  // }

  window.addEventListener('mouseover', initLandbot, { once: true });
  window.addEventListener('touchstart', initLandbot, { once: true });
  var myLandbot;
  function initLandbot() {
    if (!myLandbot) {
      var s = document.createElement('script');s.type = 'text/javascript';s.async = true;
      s.addEventListener('load', function() {
        var myLandbot = new Landbot.Livechat({
          configUrl: 'https://storage.googleapis.com/landbot.site/v3/H-1721315-KERK2IIVK1B2SXW1/index.json',
        });
      });
      s.src = 'https://cdn.landbot.io/landbot-3/landbot-3.0.0.js';
      var x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    }
  }
}
